// ----------------------------------------------------------------------

const useCountry = () => {

    const country = window.location.hostname.split('.').slice(0, -2).join('.');

    switch (country)
    {
        case 'ie':
            return {
                "id": 2,
                "name": "Ireland",
                "iso_code": "IE",
                "tld": "ie",
                "timezone": "Europe/Dublin",
                "currency": {
                    "symbol": "€",
                    "code": "EUR"
                },
                "address": {
                    "label1": "Address line 1",
                    "label2": "Address line 2",
                    "label3": "Address line 3",
                    "label4": "Address line 4",
                    "label5": "Address line 5",
                    "code": "Eircode"
                }
            };
        case 'nz':
            return {
                "id": 3,
                "name": "New Zealand",
                "iso_code": "NZ",
                "tld": "nz",
                "timezone": "Pacific/Auckland",
                "currency": {
                    "symbol": "$",
                    "code": "NZD"
                },
                "address": {
                    "label1": "Address line 1",
                    "label2": "Address line 2",
                    "label3": "Address line 3",
                    "label4": "Address line 4",
                    "label5": "Address line 5",
                    "code": "Postcode"
                }
            };
        case 'au':
            return {
                "id": 4,
                "name": "Australia",
                "iso_code": "AU",
                "tld": "au",
                "currency": {
                    "symbol": "$",
                    "code": "AUD"
                },
                "address": {
                    "label1": "Address line 1",
                    "label2": "Address line 2",
                    "label3": "Address line 3",
                    "label4": "Address line 4",
                    "label5": "Address line 5",
                    "code": "Postcode"
                }
            };
        case 'uk':
        case 'gb':
        default:
            return {
                "id": 1,
                "name": "United Kingdom",
                "iso_code": "GB",
                "tld": "uk",
                "currency": {
                    "symbol": "£",
                    "code": "GBP"
                },
                "address": {
                    "label1": "Street / building name",
                    "label2": "Address line 2",
                    "label3": "Town / village",
                    "label4": "City",
                    "label5": "County",
                    "code": "Postcode"
                }
            };
    }

};

export default useCountry;
